export default "__VITE_ASSET__CQI9sGRZ__"